import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

export type CreateCheckoutParams = {
  amount: { value: string; currency: string };
  description: string;
  returnUrl: string;
  tierId: string;
};

export async function createCheckoutSession(params: CreateCheckoutParams): Promise<{ checkoutUrl: string; paymentId: string }> {
  const fn = httpsCallable(functions, 'createMollieCheckout');
  const res: any = await fn(params);
  if (!res?.data?.ok) throw new Error('Failed to create checkout');
  return { checkoutUrl: res.data.checkoutUrl, paymentId: res.data.paymentId };
}








